export default "__VITE_PUBLIC_ASSET__1c1ce227__"